import React from 'react';

import type { ReactNode } from 'react';
import type { ViewProps } from 'react-native';

import { StyledContainer } from './styles';

interface ContainerProps extends ViewProps {
  children: ReactNode;
}

export default function Container({ children }: ContainerProps) {
  return <StyledContainer>{children}</StyledContainer>;
}
